import React from 'react';
import { FilePreviewFileInfo } from '../types';

function CommonPreview(props: { value: FilePreviewFileInfo }) {
  const { value } = props;

  return (
    <div className="asset-management-file-preview-common-content">
      {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
      <iframe src={`${value.url}#scrollbars=0&toolbar=0&statusbar=0`} />
    </div>
  );
}

export default CommonPreview;
